import type { ProjectSubmissionFormBody } from '@mogul/api-client';
import * as yup from 'yup';

export const GENRES = [
  'Action',
  'Adventure',
  'Comedy',
  'Crime and mystery',
  'Fantasy',
  'Historical',
  'Historical fiction',
  'Horror',
  'Romance',
  'Satire',
  'Science fiction',
  'Thriller',
];

export const SUB_GENRES = [
  'Action Comedy',
  'Action Thriller',
  'Martial Arts',
  'Superhero',
  'War',
  'Fantasy Adventure',
  'Anime',
  'Computer Animation',
  'Stop Motion',
  'Traditional Animation',
  'Parody',
  'Romantic Comedy',
  'Slapstick',
  'Crime Comedy',
  'Gangster',
  'Heist',
  'Biographical (Biopic)',
  'Courtroom Drama',
  'Historical Drama',
  'Melodrama',
  'Period Drama',
  'Dark Fantasy',
  'High Fantasy',
  'Sword and Sorcery',
  'Urban Fantasy',
  'Psychological Horror',
  'Slasher',
  'Supernatural Horror',
  'Zombie',
  'Musical Comedy',
  'Musical Drama',
  'Romantic Drama',
  'Romantic Fantasy',
  'Romantic Thriller',
  'Cyberpunk',
  'Dystopian',
  'Space Opera',
  'Steampunk',
  'Time Travel',
  'Crime Thriller',
  'Psychological Thriller',
  'Spy Thriller',
  'Biographical Documentary',
  'Historical Documentary',
  'Nature Documentary',
  'Sports Documentary',
];

interface ProjectSubmissionFormFiles<T> {
  reel?: T;
  image?: T;
  header?: T;
  footer?: T;
  team: { name?: string; image?: T }[];
}

export interface ProjectSubmissionFormInterface
  extends Omit<
      Omit<ProjectSubmissionFormBody, 'token'>,
      keyof ProjectSubmissionFormFiles<File | string>
    >,
    ProjectSubmissionFormFiles<File | string> {}

export const fileFields = ['reel', 'image', 'header', 'footer'] as const;

export const schema = yup.object().shape({
  name: yup.string().required('Name is required'),
  email: yup.string().email().required('Email is required'),
  phone: yup.string().optional(),
  city: yup.string().optional(),
  state: yup.string().optional(),
  country: yup.string().optional(),
  projectName: yup.string().required('Project name is required'),
  subGenres: yup.array().of(yup.string()).optional(),
  genre: yup.string().required('Genre is required'),
  screenwriter: yup.string().required('Screenwriter is required'),
  attachments: yup.string().optional(),
  era: yup.string().optional(),
  location: yup.string().optional(),
  audience: yup.string().optional(),
  original: yup.string().required('Originality is required'),
  screenplay: yup.string().optional(),
  synopsis: yup.string().optional(),
  pageCount: yup.string().optional(),
  stakeholders: yup.string().optional(),
  status: yup.string().required('Status is required'),
  budgetPercent: yup.string().required('Budget is required'),
  financialMilestones: yup.string().optional(),
  estimatedBudget: yup.string().required('Estimated budget is required'),
  mogulBudget: yup.string().required('Budget to finance is required'),
  goals: yup.string().optional(),
  distributor: yup.string().optional(),
  sellingPoints: yup.string().optional(),
  keyDates: yup.string().optional(),
  distributionStrategy: yup.string().optional(),
  synopsisLink: yup.string().optional(),
  charactersLink: yup.string().optional(),
  attachedArtist: yup.string().optional(),
  scriptLink: yup.string().optional(),
  storyLink: yup.string().optional(),
  promoteHelp: yup.string().optional(),
  utilities: yup.string().required('Perks/utilities are required'),
  initialIdeas: yup.string().optional(),
  anythingElse: yup.string().optional(),
  reel: yup.mixed().optional(),
  image: yup.mixed().optional(),
  header: yup.mixed().optional(),
  footer: yup.mixed().optional(),
  team: yup.array().of(
    yup.object().shape({
      name: yup.string().optional(),
      image: yup.mixed().optional(),
    }),
  ),
}) as yup.ObjectSchema<ProjectSubmissionFormInterface>;
